import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { ExpirationArea } from "./Styles";

export default function ExpirationDate({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Vencimiento*"
            value={!value ? document.expiration.parsed : value}
          />
        </div>
      ) : (
        <ExpirationArea>
          <Informative
            readonly={true}
            label="Vencimiento*"
            value={!value ? document.expiration.parsed : value}
          />
        </ExpirationArea>
      )}
    </>
  );
}
